export function setTokenHeader(headers = {}, token, headerName = "token") {
  if (token !== undefined && token !== null) {
    headers[headerName] = `${token}`;
  }

  return headers;
}

export function getAttemptedUrl(locationObject) {
  return `${locationObject.pathname}${locationObject.search}`;
}

export function getRefreshTokenFromResponse(response) {
  return response?.data?.data?.responseData?.[0]?.token;
}
